class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

//customElements.define('header-menu', HeaderMenu);


/* Main Menu */
let items = document.querySelector(".header__inline-menu").querySelectorAll(".mega-menu");
let dropdownItems = document.querySelector(".mega-menu__content");
items.forEach(item => {
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
    let ulElement = item.querySelector(".mega-menu__content");
    if (ulElement !== null) {
      ulElement.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        document.body.classList.remove("header-normal");
      });
    }
  });
  item.addEventListener("focus", () => {
    item.setAttribute("open", true);
    document.body.classList.add("header-normal");
  });
  item.addEventListener("blur", () => {
    item.removeAttribute("open");
    document.body.classList.remove("header-normal");
  });
  item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "");
      document.body.classList.add("header-normal");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.body.classList.remove("header-normal");
    });
});
if (dropdownItems !== null) {
  dropdownItems.addEventListener("mouseleave", () => {
    items.forEach(item => {
      item.removeAttribute("open");
      document.body.classList.remove("header-normal");
    });
  });
}

/* Right Menu */
let itemsr = document.querySelector(".header-inline-menu-right").querySelectorAll(".mega-menus");
let dropdownItemsr = document.querySelector(".mega-menu__content");
itemsr.forEach(item => {
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
    let ulElement = item.querySelector(".mega-menu__content");
    if (ulElement !== null) {
      ulElement.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        document.body.classList.remove("header-normal");
      });
    }
  });
  item.addEventListener("focus", () => {
    item.setAttribute("open", true);
    document.body.classList.add("header-normal");
  });
  item.addEventListener("blur", () => {
    item.removeAttribute("open");
    document.body.classList.remove("header-normal");
  });
  item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "");
      document.body.classList.add("header-normal");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.body.classList.remove("header-normal");
    });
});
if (dropdownItemsr !== null) {
  dropdownItemsr.addEventListener("mouseleave", () => {
    itemsr.forEach(item => {
      item.removeAttribute("open");
      document.body.classList.remove("header-normal");
    });
  });
}

